module.exports = __webpack_public_path__ + "static/dwarf_golden_male_SCAG-e4308e4c746f3a13657562159579870f.webp";